import LaunchDynamicInsightsModal from './LaunchDynamicInsightsModal';

export default LaunchDynamicInsightsModal;
